module.exports = __webpack_public_path__ + "static/images/ui/ui-bg_glass_40_0078a3_1x400.png";